import {
  Checkbox,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import React, { ChangeEvent } from 'react';
import CardMessage from '../../../../../components/CardMessage/CardMessage';
import { getSorting, stableSort } from '../../../../../utils/tableFunctions';
import useStyles from '../../styles';

export interface BatchSigningPunchCardTableData {
  signingId: number;
  employeeCode: string;
  employeeName: string;
  employeeOffice: string;
  signingStatus: boolean;
  occurrencyControl?: string;
  lunchTime?: boolean;
  totalPendingOccurrences: number;
}

type BatchSigningPunchCardTableBodyProps = {
  data: BatchSigningPunchCardTableData[];
  selectedItems: BatchSigningPunchCardTableData[];
  order: 'asc' | 'desc';
  orderBy: string;
  page: number;
  rowsPerPage: number;
  handleSelectItem: (data: BatchSigningPunchCardTableData) => void;
  handleSelectActions: (
    event: ChangeEvent<{ name?: string | undefined; value: unknown }>,
    employeeCode: string,
  ) => any;
  handleCheckLunchTime: (checked: boolean, employeeCode: string) => any;
};

const BatchSigningPunchCardTableBody = ({
  order,
  orderBy,
  rowsPerPage,
  page,
  data,
  selectedItems,
  handleSelectItem: handleSelectData,
  handleSelectActions,
  handleCheckLunchTime,
}: BatchSigningPunchCardTableBodyProps) => {
  const classes = useStyles();

  return (
    <TableBody>
      {data.length > 0 ? (
        <>
          {stableSort(data, getSorting(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row: BatchSigningPunchCardTableData, index: number) => {
              const labelId = `table-checkbox-${index}`;
              const labelCheckBox = `table-checkbox-lunch-${index}`;

              return (
                <TableRow hover tabIndex={-1} key={row.signingId}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      onClick={() => handleSelectData(row)}
                      checked={selectedItems.some(
                        item => item.signingId === row.signingId,
                      )}
                      color="primary"
                    />
                  </TableCell>
                  <TableCell
                    style={{ minWidth: 160, maxWidth: 190 }}
                    align="center"
                    id={labelId}
                  >
                    {row.employeeName}
                  </TableCell>

                  <TableCell
                    style={{ minWidth: 240, maxWidth: 270 }}
                    align="center"
                  >
                    {row.employeeOffice}
                  </TableCell>
                  <TableCell style={{ flex: 1 }} align="center">
                    {row.totalPendingOccurrences}
                  </TableCell>
                  <TableCell align="center">
                    {row.signingStatus ? (
                      <Typography color="textSecondary">Assinado</Typography>
                    ) : (
                      <Typography color="primary">Não Assinado</Typography>
                    )}
                  </TableCell>
                  <TableCell
                    style={{ flex: 1 }}
                    align="center"
                    id={labelCheckBox}
                  >
                    <Checkbox
                      color="primary"
                      checked={row.lunchTime}
                      onChange={event => {
                        handleCheckLunchTime(
                          event.currentTarget.checked,
                          row.employeeCode,
                        );
                      }}
                      disabled={row.occurrencyControl !== 'PADRAO'}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Select
                      classes={{
                        selectMenu: classes.selectMenu,
                      }}
                      defaultValue=""
                      disableUnderline
                      disabled={row.totalPendingOccurrences === 0}
                      fullWidth
                      value={row.occurrencyControl ?? 'NENHUM'}
                      onChange={event =>
                        handleSelectActions(event, row.employeeCode)
                      }
                    >
                      <MenuItem value="NENHUM" selected>
                        Nenhuma
                      </MenuItem>
                      <MenuItem value="ABONO">Abonar</MenuItem>
                      <MenuItem value="DESCONTO">Descontar</MenuItem>
                      <MenuItem value="PADRAO">Inserir Horário Padrão</MenuItem>
                    </Select>
                  </TableCell>
                </TableRow>
              );
            })}
        </>
      ) : (
        <TableRow>
          <TableCell colSpan={7} style={{ flex: 1 }} align="center">
            <CardMessage
              icon={
                <SentimentDissatisfiedIcon
                  style={{ fontSize: 100, opacity: 0.4 }}
                />
              }
              message="Nenhum resultado"
            />
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default BatchSigningPunchCardTableBody;
